/**
 * Organization certificate API – all endpoints used by certificate admin pages.
 * Base path: /admin/certificate (certificate routes mounted in backend organization routes).
 */
import { GET, POST, DELETE, UPLOAD_FILE, UPLOAD_FILE_WITH_METHOD } from '../../apiController';

const ORG_CERTIFICATE = '/admin/certificate';

export const getOrgCertificate = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`${ORG_CERTIFICATE}/templates${queryString ? '?' + queryString : ''}`);
};

export const getCertificates = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(`${ORG_CERTIFICATE}/get_certificates${queryString ? '?' + queryString : ''}`);
};

export const createCertificate = (formData) => {
  return UPLOAD_FILE(`${ORG_CERTIFICATE}/create`, formData);
};

export const editCertificate = (id, formData) => {
  return UPLOAD_FILE_WITH_METHOD(`${ORG_CERTIFICATE}/edit/${id}`, formData, 'PUT');
};

export const deleteCertificateTemplate = (id) => {
  return DELETE(`${ORG_CERTIFICATE}/delete/${id}`);
};

export const createCertificatesForRandomUsers = (data) => {
  return POST(`${ORG_CERTIFICATE}/create_random_users`, data);
};
